











































import { Component, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';

import { DATA } from '@/config/data';
import { APP_CONFIG } from '@/config/app-config';
import Loading from 'vue-loading-overlay';
import { PayAuthorityModel } from '@/models/payauthority';
import { OrderComplainModel } from '@/models/order-complain';
import payauthorityService from '@/services/payauthority-services';
import authService from '@/services/auth-services';
import CustomerInfo from './components/CustomerInfo.vue';
import PayAuthorityDetailFooter from './components/PayAuthorityDetailFooter.vue';
import AmountDetailPayAuthority from './components/AmountDetailPayAuthority.vue';
import PayAuthorityInfo from './components/PayAuthorityInfo.vue';
import ChatBox from '@/shared/components/ChatBox.vue';
import commonService from '@/services/common-services';
import ReportPayAuthorityModal from './components/ReportPayAuthorityModal.vue';
import PayAuthorityComplain from './components/PayAuthorityComplain.vue';

@Component({
    components: {
        Loading,
        'customer-info': CustomerInfo,
        'chat-box': ChatBox,
        'payauthority-detail-footer': PayAuthorityDetailFooter,
        'amount-detail-payauthority': AmountDetailPayAuthority,
        'payauthority-info': PayAuthorityInfo,
        'report-payauthority': ReportPayAuthorityModal,
        'payauthority-complain': PayAuthorityComplain,
    }
})
export default class DetailPayAuthoriry extends Vue {
    private payauthority: PayAuthorityModel = new PayAuthorityModel();
    private customerInfo: any = {};
    private isShowReportModal: boolean = false;
    private isLoading: boolean = false;
    private reportPayAuthority: any = { Status: 4, Dispute: '' };
    get payauthorityId() {
        return this.$route.params.id;
    }
    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get rate() {
      return this.$store.state[APP_CONFIG.stateKey.commonStore].rate;
    }

    private async getConfiguration() {
        const result = await commonService.configuration();
        if (result && result.status === 200) {
        (window['getApp'] as any).$emit('SET_CONFIGURATION', result.data.data);
        }
    }

    @Watch('payauthorityId', { immediate: true, deep: true })
    private async watchOrderId() {
        if (this.payauthorityId) {
            this.initComponent();
        }
    }

    private async created() {
        await this.getConfiguration();
    }

    private async initComponent() {
        await this.loadData();
        await this.getCustomersInfo();
        await this.getRate();        
    }

    private async loadData() {
        if (this.payauthorityId) {
            this.isLoading = true;
            const result = await payauthorityService.getDetail(this.payauthorityId);
            this.isLoading = false;
            if (result && result.status === 200 && (result.data.data.length > 0 || result.data.data.ID > 0)) {
                const item = result.data.data;
                
                this.payauthority = new PayAuthorityModel();
                this.payauthority.ID = item.ID;
                this.payauthority.Status = item.Status;
                this.payauthority.UID = item.UID;
                this.payauthority.Username = item.Username;
                this.payauthority.ExchangeRate = item.ExchangeRate;
                this.payauthority.Amount = item.Amount;
                this.payauthority.AmountVND = item.AmountVND;
                this.payauthority.Fee = item.Fee;
                this.payauthority.FeeVND = item.FeeVND;
                this.payauthority.TotalAmount = item.TotalAmount;
                this.payauthority.Refund = item.Refund;
                this.payauthority.Content = item.Content;
                this.payauthority.Dispute = item.Dispute;
                this.payauthority.AcceptPayAccount = item.AcceptPayAccount;
                this.payauthority.CreatedBy = item.CreatedBy;
                this.payauthority.CreatedDate = item.CreatedDate;
                this.payauthority.OrderCodes = item.OrderCodes;
                this.payauthority.NumberDetail = item.NumberDetail;
                this.payauthority.Complains = [];
                for(const complain of item.OrderComplains) {
                    const complainItem = new OrderComplainModel();
                    complainItem.amount = complain.Amount;
                    complainItem.amountNDT = complain.AmountNDT;
                    complainItem.modifiedBy = complain.ModifiedBy;
                    complainItem.modifiedDate = complain.ModifiedDate ? moment(complain.ModifiedDate).format('DD-MM-YYYY HH:mm:ss') : '';
                    complainItem.noteForUser = complain.NoteForUser;
                    complainItem.noteOfStaff = complain.NoteOfStaff;
                    complainItem.orderId = complain.OrderID;
                    complainItem.orderType = complain.OrderType;
                    complainItem.receivedId = complain.ReceivedID;
                    complainItem.status = complain.Status;
                    complainItem.statusObj = (DATA.complainStatusList.find(x => x.value === complain.Status) || { value: 0, name: 'Khác', color: '#3b4354' });
                    complainItem.uId = complain.UID;
                    complainItem.complainText = complain.ComplainText;
                    complainItem.userName = complain.Username;
                    complainItem.createBy = complain.CreatedBy;
                    complainItem.createDate = moment(complain.CreatedDate).format('DD-MM-YYYY HH:mm:ss');
                    complainItem.exchangeRate = complain.ExchangeRate;
                    complainItem.id = complain.ID;
                    complainItem.img = complain.IMG;
                    complainItem.isBroken = complain.IsBroken;
                    complainItem.isMissGood = complain.IsMissGood;
                    complainItem.isLoss = complain.IsLoss;
                    complainItem.isOther = complain.IsOther;
                    complainItem.isOption = complain.IsOption;
                    complainItem.resMethod = complain.ResMethod;
                    this.payauthority.Complains.push(complainItem);
                }
            } else {
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thông báo!',
                    text: `Không tìm thấy đơn ủy quyền [${this.payauthorityId}]`,
                });
            }
        }
    }

    private async getRate() {
      const result = await commonService.exchangeRate();
      if (result && result.status === 200) {
        (window['getApp'] as any).$emit('SET_RATE', result.data.data.exchange_rate);
      }
    }

    private async getCustomersInfo() {
        const result = await authService.customersInfo(this.userInfo.userId);
        if(result && result.status === 200) {
            this.customerInfo = result.data.data || {};
            (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
        }
    }

    private async onReloadOrder() {
        await await this.loadData();
    }

    private async onAcceptReportModal() {
        if (!this.reportPayAuthority.Dispute) {
            Vue.notify({ group: 'foo', type: 'error', title: 'Thông báo!', text: 'Nội dung khiếu nại chưa điền!' });
        } else {
            this.isShowReportModal = false;
            this.isLoading = true;
            this.reportPayAuthority.OrderCodes = [];
            const result = await payauthorityService.updateDetail(this.payauthority.ID || 0, this.reportPayAuthority);
            this.isLoading = false;
            if (result && result.status === 200 && result.data.status === 200) {
                Vue.notify({
                    group: 'foo',
                    type: 'success',
                    title: 'Thông báo!',
                    text: 'Gửi khiếu nại đơn ủy quyền thành công!',
                });
                this.onReloadOrder();
            } else {
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thông báo!',
                    text: `Có lỗi khi cập nhật hệ thống!`,
                });
            }
        }
    }
    private onCloseReportModal() {
        this.isShowReportModal = false;
    } 
    private onShowReport() {
        this.isShowReportModal = true;
    }
}
